import React from "react";
import AccountListItem from "./accountListItem";

// import data from "./data"
import "./style.scss";

const AccountList = ({ data, parentCategory, blockMode }) => (
  <div className="accounts-list">
    {data.map((item) => (
      <AccountListItem
        {...item}
        parentCategory={parentCategory}
        blockMode={blockMode}
      />
    ))}
  </div>
);

export default AccountList;
